import React from 'react';
import { Link } from 'react-router-dom';

const Services: React.FC = () => {
  const services = [
    {
      title: 'Portrait Photography',
      description: 'Professional headshots and personal portraits that capture your unique personality and style.',
      features: ['Studio or outdoor sessions', 'Professional lighting setup', 'Wardrobe consultation', 'Digital gallery delivery'],
      image: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?ixlib=rb-4.0.3&auto=format&fit=crop&w=764&q=80'
    },
    {
      title: 'Wedding Photography',
      description: 'Complete wedding coverage from preparation to celebration, capturing every precious moment.',
      features: ['Full day coverage', 'Engagement session included', 'Online gallery', 'Print release included'],
      image: 'https://images.unsplash.com/photo-1606216794074-735e91aa2c92?ixlib=rb-4.0.3&auto=format&fit=crop&w=687&q=80'
    },
    {
      title: 'Events Photography',
      description: 'Professional event photography for conferences, galas, and corporate gatherings.',
      features: ['Event coverage', 'Candid and posed shots', 'Same-day preview', 'Corporate branding'],
      image: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=1469&q=80'
    }
  ];

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-black text-white">
        <div className="section-padding text-center">
          <h1 className="font-serif text-5xl md:text-6xl mb-6">Our Services</h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Professional photography services tailored to meet your unique needs, 
            delivered with artistic excellence and attention to detail.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="section-padding">
          <div className="grid lg:grid-cols-2 gap-16">
            {services.map((service, index) => (
              <div key={index} className="group">
                <div className="grid md:grid-cols-2 gap-8 items-center">
                  <div className={`${index % 2 === 1 ? 'md:order-2' : ''}`}>
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="w-full h-80 object-cover transition-all duration-500"
                    />
                  </div>
                  <div className={`${index % 2 === 1 ? 'md:order-1' : ''}`}>
                    <h3 className="font-serif text-3xl mb-4">{service.title}</h3>
                    <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
                    
                    <ul className="space-y-2 mb-6">
                      {service.features.map((feature, featureIndex) => (
                        <li key={featureIndex} className="flex items-center text-gray-600">
                          <svg className="w-4 h-4 mr-3 text-black" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                          {feature}
                        </li>
                      ))}
                    </ul>
                    
                    <a href="https://app.somapix.com/profile/graphiczonestudio" target="_blank" rel="noopener noreferrer" className="btn-primary">
                      Book Now
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-studio-gray">
        <div className="section-padding">
          <div className="text-center mb-16">
            <h2 className="font-serif text-4xl md:text-5xl mb-4">Our Process</h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              From initial consultation to final delivery, we ensure a seamless and professional experience
            </p>
          </div>
          
          <div className="grid md:grid-cols-4 gap-8">
            {[
              { step: '01', title: 'Consultation', description: 'We discuss your vision, requirements, and creative goals' },
              { step: '02', title: 'Planning', description: 'Detailed planning including location, styling, and timeline' },
              { step: '03', title: 'Photography', description: 'Professional shoot with attention to every detail' },
              { step: '04', title: 'Delivery', description: 'Edited images delivered through secure online gallery' }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-black text-white rounded-full flex items-center justify-center font-serif text-xl mb-4 mx-auto">
                  {item.step}
                </div>
                <h3 className="font-serif text-xl mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>


    </div>
  );
};

export default Services;